// import TweenLite from './vendor/TweenLite';
// import { qs, qsArray } from './utilities/selectors';
import { qs, qsArray, isInternetExplorer, isEdge, trackEvent } from "./utilities/index"
import Application from "./application"
import Overlay from "./overlay"

let Question = function (params) {
	// console.log('Question initalizing ' + params);

	/**
	 *
	 */
	let self = this
	let elementId = params.elementId
	let QuestionElement = document.getElementById(params.elementId)
	// 'multiple-choice' or 'range-slider'
	let type = QuestionElement.getAttribute("data-question-type")
	let background = QuestionElement.querySelector(".bg-image")
	let progress = QuestionElement.querySelector(".progress")
	let text = QuestionElement.querySelector(".question-wrap")
	let importantButton = QuestionElement.querySelector(".btn-important")
	let contentImage = QuestionElement.querySelector(".content-image")
	let controls = QuestionElement.querySelector(".controls")
	let answers = qsArray(".answer", QuestionElement)
	let slider = QuestionElement.querySelector(".slider")
	let nextButton = QuestionElement.querySelector(".next-button")
	let previousButton = QuestionElement.querySelector(".previous-button")
	let timeline
	let selectedAnswerId = ""
	let selectedDirection = 0
	let sliderTween1 = null
	let sliderTween2 = null
	let sliderTween3 = null
	let overlay = new Overlay()
	// console.log('answers is ' + answers);
	// console.log('slider is ' + slider);
	// console.log('question type is ' + type);

	this.open = function () {
		// console.log('Question.open');
		window.ironSelector.fillProgressBar()
		TweenLite.set([background, progress, text, contentImage, controls], { opacity: 0 })
		TweenLite.set(answers, { opacity: 0 })
		if (slider !== null) {
			TweenLite.set(slider, { opacity: 0 })
		}
		QuestionElement.style.display = "block"
		timeline = new TimelineLite({ onComplete: this.openComplete, onCompleteScope: this })
		timeline.to(background, Application.tweenLength, { opacity: 1 })
		timeline.to(progress, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.to(text, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.to(contentImage, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		for (let x = 0; x < answers.length; x++) {
			timeline.to(answers[x], Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		if (slider !== null) {
			timeline.to(slider, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		timeline.to(controls, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.play()
	}

	this.openComplete = function () {
		if (type === "multiple-choice") {
			this.initialzeImportantButton()
			this.initializeAnswers()
			this.initializePreviousButton()
			// this.initializeNextButton();
			if (selectedAnswerId !== "") {
				this.initializeNextButton()
			}
		} else if (type === "range-slider") {
			this.initialzeImportantButton()
			this.initializeSlider()
			this.initializePreviousButton()
			this.initializeNextButton()
		}
	}

	this.initializeAnswers = function () {
		// console.log('init answers ' + this.answerClicked);
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.addEventListener("click", this.answerClicked)
		}
		// console.log('question has ' + answers.length + ' answers');
	}

	this.disableAnswers = function () {
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.removeEventListener("click", this.answerClicked)
		}
	}

	this.initializeSlider = function () {
		if (slider !== null) {
			this.input = slider.querySelector("input")
			this.value = slider.querySelector(".value")

			if (isInternetExplorer() === true) {
				// chrome slider released, works in ie
				this.input.addEventListener("change", this.sliderChanged)
			} else {
				// chrome slider moved, doesn't work in ie works in edge and everything else
				this.input.addEventListener("input", this.sliderChanged)
			}

			if (elementId !== "question-2") {
				this.sliderImage1 = QuestionElement.querySelector(".slider-image-1")
				this.sliderImage2 = QuestionElement.querySelector(".slider-image-2")
				this.sliderImage3 = QuestionElement.querySelector(".slider-image-3")
			}
		}
	}

	this.sliderChanged = function () {
		console.log("changed: " + elementId)
		if (elementId === "question-2") {
			// update the display for question 2 distances
			let display = self.input.value
			if (display < 100) {
				display = "<100"
			} else if (display > 200) {
				display = ">200"
			}
			let units = QuestionElement.getAttribute("data-answer-units")
			if (units === null || units === undefined || units === "") {
				units = "yards"
			}
			self.value.innerHTML = display.toString() + " " + units
		} else {
			//swap images for other sliders
			let index = self.input.value
			let tweenLength = 0.1
			let delayLength = 0
			if (sliderTween1 !== null) {
				sliderTween1.kill()
				sliderTween2.kill()
				sliderTween3.kill()
				sliderTween1 = null
				sliderTween2 = null
				sliderTween3 = null
			}
			// question 4 is full fade to black
			if (elementId === "question-4") {
				tweenLength = 0.25
				delayLength = 0.25 // console.log('show slider image ' + index);
				if (index.toString() === "1") {
					sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, {
						opacity: 0,
						onComplete: function () {
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 1 })
						}
					})
					sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
					sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
				} else if (index.toString() === "2") {
					sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
					sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, {
						opacity: 0,
						onComplete: function () {
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 1 })
						}
					})
					sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
				} else if (index.toString() === "3") {
					sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
					sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
					sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, {
						opacity: 0,
						onComplete: function () {
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							TweenLite.set(self.sliderImage1, { opacity: 0 })
							sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 1 })
						}
					})
				}
			} else {
				// question 5 and 6 is crossfade
				// console.log('show slider image ' + index);
				if (index.toString() === "1") {
					sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 1 })
					sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
					sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
				} else if (index.toString() === "2") {
					sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
					sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 1 })
					sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
				} else if (index.toString() === "3") {
					sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
					sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
					sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 1 })
				}
			}
		}
	}

	this.initialzeImportantButton = function () {
		if (importantButton !== null) {
			// console.log('enable important button');
			importantButton.addEventListener("click", this.importantButtonClicked)
		}
	}

	this.initializePreviousButton = function () {
		// console.log('init previous button ' + previousButton);
		previousButton.addEventListener("click", this.previousClicked)
	}

	this.initializeNextButton = function () {
		// console.log('init next button ' + nextButton);
		nextButton.addEventListener("click", this.nextClicked)
		nextButton.classList.remove("disabled")
		// nextButton.classList.add('enabled');
	}

	this.disableControls = function () {
		// console.log('disable important button');
		if (importantButton !== null) {
			importantButton.removeEventListener("click", this.importantButtonClicked)
		}
		previousButton.removeEventListener("click", this.previousClicked)
		nextButton.removeEventListener("click", this.nextClicked)
	}

	this.answerClicked = function (event) {
		// console.log('Question.answerClicked ' + event.target.id);
		// console.log('selected answer id was ' + self.selectedAnswerId);
		if (selectedAnswerId === "") {
			self.initializeNextButton()
		}
		self.resetAnswers()
		// if its multiple choice set values here, if its slider set it in nextClicked
		selectedAnswerId = event.target.id
		event.target.classList.add("selected")
		// console.log('now selected answer id is ' + self.selectedAnswerId);
	}

	this.resetAnswers = function () {
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.classList.remove("selected")
		}
		selectedAnswerId = ""
	}

	this.importantButtonClicked = function () {
		overlay.openImportantWindow(elementId)
	}

	this.previousClicked = function (event) {
		// console.log('Question.previousClicked ' + event.target.id);
		self.selectedDirection = -1
		self.close()
		// window.ironSelector.questionClosed(-1);
		trackEvent("navigation", "Previous")
	}

	this.nextClicked = function (event) {
		// console.log('Question.previousClicked ' + event.target.id);
		self.selectedDirection = 1
		// if its a slider set values here, if its multiple choice values set in answerClicked
		if (type === "range-slider") {
			if (elementId === "question-2") {
				let val = parseInt(self.input.value, 10)
				if (val <= 100) {
					selectedAnswerId = "question-2a1"
				} else if (val <= 125) {
					selectedAnswerId = "question-2a2"
				} else if (val <= 150) {
					selectedAnswerId = "question-2a3"
				} else if (val <= 175) {
					selectedAnswerId = "question-2a4"
				} else if (val < 200) {
					selectedAnswerId = "question-2a5"
				} else {
					selectedAnswerId = "question-2a6"
				}
			} else {
				selectedAnswerId = elementId + "a" + self.input.value
			}
		}
		// store answer in the main application history
		window.ironSelector.storeAnswer(selectedAnswerId)
		// close it up
		self.close()
		trackEvent("answer", elementId, selectedAnswerId)
		trackEvent("navigation", "Next")
	}

	this.close = function () {
		// console.log('close ' + selectedAnswerId);
		this.disableAnswers()
		this.disableControls()
		window.ironSelector.clearProgressBar(self.selectedDirection)
		timeline.kill()
		timeline = new TimelineLite({ onComplete: closeComplete, onCompleteScope: this })
		timeline.to(controls, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		for (let x = answers.length - 1; x >= 0; x--) {
			timeline.to(answers[x], Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		if (slider !== null) {
			timeline.to(slider, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		timeline.to(contentImage, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(text, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(progress, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(background, Application.tweenLength, { opacity: 0 })
		timeline.timeScale(2)
		timeline.play()
	}

	function closeComplete() {
		// console.log('closeComplete ' + this.selectedDirection);
		timeline.kill()
		timeline = null
		// content.style.display = 'none';
		QuestionElement.style.display = "none"
		window.ironSelector.questionClosed(this.selectedDirection)
	}
}

export default Question
